import {FC} from 'react'

type Props = {
  data: number
}

const ErItemValue: FC<Props> = ({data}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>{data === 0 ? '-' : data}</div>
    </div>
  )
}

export {ErItemValue}
